import { gql } from "@apollo/client";

export const newMobileResponseMutation = gql`
  mutation NewMobileResponse($input: MobileServiceInput!) {
    newMobileResponse(input: $input) {
     response
    }
  }
`;


export const updateMobileResponseMutation = gql`
  mutation updateRecurringTemplate($input: MobileServiceInput!) {
    updateRecurringTemplate(input: $input) {
     response
    }
  }
`;






export const UpdateResponseStatusMutation = gql`
  mutation UpdateResponseStatusById(
    $responseId: String!
    $isReportSubmitted: Boolean!
  ) {
    updateResponseStatusById(
      responseId: $responseId
      isReportSubmitted: $isReportSubmitted
    ) {
      message
    }
  }
`;





export const cancelResponseByIdMutation = gql`
  mutation cancelResponseById(
    $responseId: String!
    $reason: String!
    $comments: String

  ) 
  {
    cancelResponseById(
      responseId: $responseId
      reason: $reason
      comments: $comments
    ) {
      message
    }
  }
`;


export const stopUntilFurtherNoticeByTemplateIdMutation = gql`
  mutation stopUntilFurtherNoticeByTemplateId(
  $templateId: String!
  $stopDate: String!
  $isCancelled: Boolean!
  $reason: String!
  $comments: String
  $siteStatus: String
)
{
  stopUntilFurtherNoticeByTemplateId(
    templateId: $templateId
    stopDate: $stopDate
    isCancelled: $isCancelled
    reason: $reason
    comments: $comments
    siteStatus: $siteStatus
  ) {
      message
    }
}
`;

// Site-level counterpart used by the termination check modal - stops every
// active mobile service template for a site at once and cancels their
// loaded duties beyond the cutoff date.
export const stopMobileServiceTemplatesBySiteIdMutation = gql`
  mutation stopMobileServiceTemplatesBySiteId(
  $siteId: String!
  $stopDate: String!
  $reason: String!
)
{
  stopMobileServiceTemplatesBySiteId(
    siteId: $siteId
    stopDate: $stopDate
    reason: $reason
  ) {
      message
      response
    }
}
`;



export const UpsertMobileResponseETAMutation = gql`
  mutation UpsertMobileResponseETA($responseId: String!, $eta: String!, $notes: String!) {
    upsertMobileResponseETA(responseId: $responseId, eta: $eta, notes:$notes) {
      message
    }
  }
`;


export const CancellAllResponseTaskByTemplateIdMutation = gql`
  mutation CancelAllResponseByTemplateId(
    $templateId: String!
    $reason: String!
    $date: String!
    $comments: String
  ) {
    cancelAllResponseByTemplateId(
      templateId: $templateId
      reason: $reason
      date: $date
      comments: $comments
    ) {
      message
      response
    }
  }
`;


export const transferTaskMutation = gql`
  mutation TransferTask($input: TransferTaskInput!) {
    transferTask(input: $input) {
      message
      response
    }
  }
`;


export const addMobileServiceNoteMutation = gql`
  mutation AddMobileServiceNote($input: AddMobileServiceNoteInput!) {
    addMobileServiceNote(input: $input) {
      message
      response
    }
  }
`;


export const updateMobileServiceNoteMutation = gql`
  mutation UpdateMobileServiceNote($input: UpdateMobileServiceNoteInput!) {
    updateMobileServiceNote(input: $input) {
      message
      response
    }
  }
`;


export const removeMobileServiceNoteReminderMutation = gql`
  mutation RemoveMobileServiceNoteReminder($noteId: String!) {
    removeMobileServiceNoteReminder(noteId: $noteId) {
      message
      response
    }
  }
`;

// Business Analysis: mark mobile jobs as invoiced (their own store, alongside markSchedulesInvoiced).
export const markMobileServicesInvoicedMutation = gql`
mutation($items: JSON!){
  markMobileServicesInvoiced(items: $items) {
    message
    response
  }
}
`;
